import Smartphones from 'Employees/views/EmployeesListView/containers/Smartphones'
import Tablets from 'Employees/views/EmployeesListView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'

const EmployeesListView = getCurrentDeviceView(Smartphones, Tablets)

export default EmployeesListView
